<script setup>

    import { computed } from 'vue'

    import { handleBlur } from '@/Helpers'


    const props = defineProps({
        care_schedule_search: {
            type: Object,
            required: true
        },
        search_enable_days: {
            type: Array,
            required: true
        },
    })

    const weekDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const noEitherAvailabilitySchedule = computed(() => {
        return weekDays.every(day => props.care_schedule_search[day].has_either_availability_schedule === false);
    })

    const scheduleFreshNessTheme = computed(() => {
        if (noEitherAvailabilitySchedule.value) {
            if (props.search_enable_days.length === 0) {
                return 'gray';
            }
        }

        if (props.care_schedule_search.freshness === 'up-to-date') {
            return 'green';
        }

        if (props.care_schedule_search.freshness === 'in-middle') {
            return 'yellow';
        }

        return 'red';
    })

    const dayTheme = (day) => {
        if (props.search_enable_days.length === 0) {
            if (props.care_schedule_search[day].has_either_availability_schedule) {
                return 'blue';
            }
            return 'gray';
        }

        if (props.search_enable_days.includes(day)) {
            if (props.care_schedule_search[day].match_type === 'full') {
                return 'green';
            }

            if (props.care_schedule_search[day].match_type === 'partial') {
                return 'yellow';
            }

            return 'red';
        }

        return 'gray';
    }

</script>

<template>

    <div :class="[
        'p-1 rounded-xl',
        {
            'bg-[#3F911A4D]' : scheduleFreshNessTheme === 'green',
            'bg-[#E6A4394D]' : scheduleFreshNessTheme === 'yellow',
            'bg-[#AB21004D]' : scheduleFreshNessTheme === 'red',
            'bg-[#E0E0E0]' : props.search_enable_days.length === 0 && noEitherAvailabilitySchedule,
        }
    ]">
        <div :class="[
            'bg-white flex gap-2 justify-between outline-[1.5px] outline-dashed px-3 py-1 rounded-lg',
            {
                'outline-gray-300': props.search_enable_days.length === 0 && noEitherAvailabilitySchedule,
                'outline-lifeworx-green-500': scheduleFreshNessTheme === 'green',
                'outline-lifeworx-yellow-600': scheduleFreshNessTheme === 'yellow',
                'outline-lifeworx-red-400': scheduleFreshNessTheme === 'red',
            }
        ]">
            <div v-for="day in weekDays" :key="day" class="flex flex-col">
                <VDropdown
                    :triggers="props.care_schedule_search[day].no_match_reasons.length ? ['hover'] : []"
                    :popperTriggers="props.care_schedule_search[day].no_match_reasons.length ? ['hover'] : []"
                    :distance="10"
                    :skidding="-10"
                    placement="top-start"
                    @apply-hide="handleBlur"

                >
                    <div :class="[
                        'font-bold capitalize text-center -mb-1',
                        {
                            'text-gray-200': dayTheme(day) === 'gray',
                            'text-lifeworx-blue-700': dayTheme(day) === 'blue',
                            'text-lifeworx-green-600': dayTheme(day) === 'green',
                            'text-lifeworx-yellow-600': dayTheme(day) === 'yellow',
                            'text-lifeworx-red-600': dayTheme(day) === 'red',
                        }
                    ]">
                        {{ day.charAt(0) }}
                    </div>
                    <div
                        :class="[
                            'text-[4px] text-center',
                            {
                                'text-gray-200': !props.care_schedule_search[day].worked_last_period,
                                'text-lifeworx-blue-600': props.care_schedule_search[day].worked_last_period,
                            }
                        ]"
                    >
                        &#11044;
                    </div>
                    <template
                        v-if="props.care_schedule_search[day].no_match_reasons.length"
                        #popper
                    >
                        <ul class="p-5">
                            <li
                                v-for="reason in props.care_schedule_search[day].no_match_reasons"
                                class="text-sm"
                            >
                                {{ reason }}
                            </li>
                        </ul>
                    </template>
                </VDropdown>
            </div>
        </div>
    </div>

</template>
